import styled from 'styled-components';

export const UploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const UploadLabel = styled.label`
  font-size: 14px;
  font-weight: 400;
  color: #666;
  margin-bottom: 8px;
`;

export const UploadHiddenInput = styled.input`
  display: none;
`;

export const UploadButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  max-width: 400px;
  height: 96px;
  background-color: #fafafa;
  border: 1.5px solid #4096ff;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #f0f5ff;
    border-color: #1677ff;
  }

  &:active {
    background-color: #e6f4ff;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const UploadIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const UploadText = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #666;
  user-select: none;
`;

export const ImagePreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
  max-width: 400px;
`;

export const ImagePreview = styled.img`
  width: 100%;
  max-width: 400px;
  height: 96px;
  border-radius: 8px;
  object-fit: contain;
  border: 1.5px solid #d9d9d9;
  background-color: #fafafa;
`;

export const RemoveImageButton = styled.button`
  padding: 8px 16px;
  background-color: #fff;
  border: 1px solid #ff4d4f;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #ff4d4f;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #ff4d4f;
    color: #fff;
  }

  &:active {
    background-color: #d9363e;
  }
`;

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  justify-content: end;
  font-size: 14px;
  font-weight: 400;
  color: #333;
`;

export const RequiredAsterisk = styled.span`
  color: #ff4d4f;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`;

export const SecondContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`;

export const GlobalWrraper = styled.div`
  display: flex;
  gap: 16px;
`;

export const ErrorText1 = styled.div`
  color: #e63946;
  font-weight: 600;
  padding: 3px 0 2px 0;
  display: flex;
  gap: 3px;
  justify-content: start;
  font-size: 12px;
  line-height: 12px;
  position: absolute;
  margin-top: -12px;
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ErrorText2 = styled.div`
  color: #e63946;
  font-weight: 600;
  padding: 3px 0 2px 0;
  display: flex;
  gap: 3px;
  justify-content: start;
  font-size: 12px;
  line-height: 12px;
  position: absolute;
  margin-top: -6px;
`;

export const ErrorText4 = styled.div`
  color: #e63946;
  font-weight: 600;
  padding: 3px 0 2px 0;
  display: flex;
  gap: 3px;
  justify-content: start;
  font-size: 12px;
  line-height: 12px;
  position: absolute;
`;

export const ModalFormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const ErrorText = styled.div`
  color: #e63946;
  font-weight: 600;
  padding: 3px 0 2px 0;
  display: flex;
  gap: 3px;
  justify-content: start;
  font-size: 12px;
  line-height: 12px;
  position: absolute;
  margin-top: -20px;
`;

export const ErrorText3 = styled.div`
  color: #e63946;
  font-weight: 600;
  padding: 3px 0 2px 0;
  display: flex;
  gap: 3px;
  justify-content: start;
  font-size: 12px;
  line-height: 12px;
`;
